module.exports = __webpack_public_path__ + "Juego-e5b53916.webp";